export default __webpack_public_path__ + "static/media/banner3.60b5e699.png";